const navCls = "_61n1e1lfuh";
const navListCls = "_61nbyn67k";
const listItemCls = "_61l1p0gc9v";
const linkCls = "_61l1g6cbju";
const itemIconCls = "_61i1t9nhf0";
const stateWrapperCls = "_61s8g0mq1";
const throbberWrapperCls = "_61thecuxd";
const throbberCls = "_61t1xrkyx5";
const chevronCls = "_61cpzmbu1";
const scrollChevronCls = "_61s1ku8h4e";

export { chevronCls, itemIconCls, linkCls, listItemCls, navCls, navListCls, scrollChevronCls, stateWrapperCls, throbberCls, throbberWrapperCls };
import "./Navigation.style.linaria.module.css";
//# sourceMappingURL=Navigation.style.js.map
